export default function LoadingSpinner() {
  return <span className="loading-spinner" />;
}
